// src/components/QuickBesoinModal.js
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import BesoinEditor from "./BesoinEditor";

const QuickBesoinModal = ({ show, onClose, onSave, scanResultId = null, existingBesoin = null, readOnly = false }) => {
  const { t } = useTranslation();

  // Masque temporairement cette 1ère modale pendant que la 2ème modale
  // (choix du statut, affichée uniquement en création) est ouverte.
  const [isHiddenForStatusModal, setIsHiddenForStatusModal] = useState(false);

  // Réinitialise le masquage à chaque (ré)ouverture/fermeture de la modale.
  useEffect(() => {
    if (!show) setIsHiddenForStatusModal(false);
  }, [show]);

return (
  <Modal
    show={show}
    onHide={onClose}
    centered
    contentClassName="besoin-modal-content"
    className={isHiddenForStatusModal ? "besoin-modal-force-hidden" : undefined}
    backdrop={isHiddenForStatusModal ? false : true}
    keyboard={!isHiddenForStatusModal}
  >
    <Modal.Header className="besoin-modal-header">

      <Modal.Title>
        {readOnly
          ? t('besoin.input.view_title', { defaultValue: 'Détails du besoin' })
          : existingBesoin
          ? t('besoin.input.edit_title')
          : t('besoin.input.new_title')}
      </Modal.Title>
    </Modal.Header>

    <Modal.Body>
      <BesoinEditor
        onSave={onSave}
        onCancel={onClose}
        scanResultId={scanResultId}
        existingBesoin={existingBesoin}
        showStatus={!!existingBesoin}
        onStatusModalOpen={() => setIsHiddenForStatusModal(true)}
        onStatusModalClose={() => setIsHiddenForStatusModal(false)}
        readOnly={readOnly}
      />
    </Modal.Body>
  </Modal>
);
};

export default QuickBesoinModal;